import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private tokenUrl = environment.keycloak.tokenUrl;
  private clientId = environment.keycloak.clientId;

  constructor(private http: HttpClient, private router: Router) {}

  // login(username: string, password: string) {
  //   const body = new HttpParams()
  //     .set('grant_type', 'password')
  //     .set('client_id', this.clientId)
  //     .set('username', username)
  //     .set('password', password);

  //   return this.http.post(this.tokenUrl, body.toString(), {
  //     headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  //   });
  // }

  saveToken(token: string) {
    localStorage.setItem('kc_access_token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('kc_access_token');
  }

  logout() {
    localStorage.removeItem('kc_access_token');
    this.router.navigate(['/login']);
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }
}
